import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDatePicker, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';

import { Table } from 'antd';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { getStorage, setStorage, updateFilterUrl } from "../../helper.js";



export default function InventoryReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const [fy] = useOutletContext();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);





  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    setValue,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])

    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'inventory-report', 1), { replace: location.search ? true : false })


  };





  const headers = [
    { label: "S.no.", key: "sno" },
    { label: "Item", key: "name" },
    { label: "Rate (Avg.)", key: "rate" },
    { label: "Stock", key: "stock" },
    { label: "Stock Value", key: "amount" }

  ];

  const pdf_columns = [
    {
      title: 'S.no.',
      dataIndex: 'sno',
      key: 'sno',
      colspan: 2

    },
    {
      title: 'Item',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Rate (Avg.)',
      dataIndex: 'rate',
      key: 'rate',
      align: 'right',
    },

    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
      align: 'right',
    },
    {
      title: 'Stock Value',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
    }


  ];

  const pdf_columns1 = [
    {
      title: 'S.no.',
      dataIndex: 'sno',
      key: 'sno',
      width: 20,
      colspan: 2
    },
    {
      title: 'Item',
      dataIndex: 'name',
      key: 'name',
    },


    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
      align: 'right',
      width: 20
    },
    {
      title: 'Remark',
      dataIndex: '',
      key: '',
      width: 60,
    }


  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/inventory_report" + filter
    );

    var dataa = data;

    return dataa;

  }

  const defaultValues = {
    date: null,
  };



  useEffect(() => {
    queryClient.invalidateQueries(['inventory-report'])
  }, [fy]);


  useEffect(() => {

    if (location.search) {
    } else {
      setFilter(defaultValues)
    }




  }, [location]);



  useEffect(() => {


    const parsed = queryString.parse(location.search);



    setFilter(parsed)




  }, []);


  const columns = [
    {
      title: 'S.no.',
      width: '30px',
      dataIndex: 'sno',
      onCell: (a, index) => ({
        colSpan: a.sno == 'Total' ? 2 : 1,
      })
    },
    {
      title: 'Item',
      width: '100px',
      dataIndex: 'name',
      sorter: 'name',
      sortOrder: parsed.sort_by == 'name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'name' && parsed.sort == 'desc' ? 'descend' : '',
      onCell: (a, index) => ({
        colSpan: a.sno == 'Total' ? 0 : 1,
      })
    },

    {
      title: 'Rate (Avg.)',
      width: '100px',
      dataIndex: 'rate',
      align: 'right',
      
    },

    {
      title: 'Stock',
      width: '100px',
      dataIndex: 'stock',
      sorter: 'stock',
      align: 'right',
      sortOrder: parsed.sort_by == 'stock' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'stock' && parsed.sort == 'desc' ? 'descend' : '',
    },
    {
      title: 'Stock Value',
      width: '100px',
      dataIndex: 'amount',
      align: 'right',
    },



  ];




  const { data, error, isError, isLoading, isFetching } = useQuery(["inventory-report", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        date: filter.date ? filter.date : data && data.date ? data.date : null,
        type: filter.type ? filter.type : null
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {

    if (data && data.date) {
      setValue('date', data.date)
    }

  }, [data]);







  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }

    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }


    if (location.search) {
      navigate('/inventory-report?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/inventory-report?' + currentUrlParams.toString())
    }




  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };








  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Inventory Report
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Inventory Report" >
            {data.items &&
              <>
                <ExportPDFButton columns={pdf_columns1} lastbold={true} data={data.items} title="inventory-report" company={data.company} company_desc={data.company_desc} heading1="Inventory Report" heading2="" heading3={`As on ${data.date}`} />
                <ExportPDFButton columns={pdf_columns} lastbold={true} data={data.items} title="inventory-report" company={data.company} company_desc={data.company_desc} heading1="Inventory Report" heading2="" heading3={`As on ${data.date}`} className="ms-2" />
                <CSVLink data={data.items} filename={"inventory-report.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4 pb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">

                  <div className="col-md-2">

                    <Controller

                      name="date"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="Date"
                          onChange={onChange}
                          default_val={value}
                          message={errors.date?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-2">
                    <UiSelect

                      required={true}
                      label="Type"
                      name="type"
                      options={['All Items', 'In Stock Only']}
                      {...register('type')}

                    />
                  </div>

                  <div className="col-md-2">
                    <UiInput
                      label="Search"
                      type="text"

                      name="search"

                      {...register("search")}
                    />
                  </div>
                  <div className="col-md-2">

                    <UiSelect
                      name='group_id'
                      label="Item Group"
                      message={errors.group_id?.message}
                      options={data.groups}
                      {...register(`group_id`)}
                    />

                  </div>





                  <div className="col-md-1" style={{ paddingTop: '28px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>




            <Table
              locale={{
                emptyText: (<TableZero title="Parties" />)
              }}

              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              pagination={false}
              loading={{ spinning: (tableDisable || isFetching) }}
              onChange={handleTableChange}
              rowClassName={(sa) => sa.sno == 'Total' && 'fw-bold bg-light'}
              scroll={{
                x: 960,

              }}

            />

          </div>
        </div>
      </div>
    </>
  );
}
